RivalIQ.apps.Dashboard.module('router', function (router, App, Backbone, Marionette, $, _) {

    'use strict';

    const Router = Marionette.Dashboard.Router;

    const defaultClickHandler = Router.navigationClickHandler;
    Router.navigationClickHandler = function (window, router, e) {
        const me = this;
        const originalHref = Backbone.$(this).attr('href');

        // remove leading and trailing slashes
        const href = originalHref.replace(/^\/+|\/+$/g, '');

        const isRedirectClick = _.some(router.redirectToDashboardRoutes, function (route) {
            return route.test(href);
        });

        // if the href is a "redirectToDashboard" link then just prevent it
        if (isRedirectClick) {
            e.preventDefault();
        } else {

            if (!e.skipNavigationInterceptor && router?.loadedCuration?.navigationInterceptor) {
                const originalArgs = arguments;
                const allowNavigation = router?.loadedCuration?.navigationInterceptor(() => {
                    const handledClick = defaultClickHandler.apply(me, originalArgs);
                    if (!handledClick) {
                        window.location = originalHref;
                    }
                });
                if (!allowNavigation) {
                    e.preventDefault();
                    return;
                }
            }

            defaultClickHandler.apply(me, arguments);
        }
    };

    router.Router = Router.extend({
        mount: function (id, path, Curation) {
            const me = this;
            // NOTE we want to optionally support a trailing slash on our
            // routes, considering this may not be general behavior it is
            // defined here rather than upstream in the library
            const slashPath = `${path}(/)`;

            const paths = Router.prototype.mount.call(this, id, slashPath, Curation);

            // if this is a "redirectToDashboard" curation, save all the paths so we can test for them
            me.redirectToDashboardRoutes = me.redirectToDashboardRoutes || [];
            if (Curation.prototype.redirectToDashboard) {
                _.each(paths, function (path) {
                    me.redirectToDashboardRoutes.push(me._routeToRegExp(path));
                });
            }

            return paths;
        },
        route: function (path, name, callback) {
            const handler = function (pathParams, queryParams) {
                RivalIQ.execute('tracking:update');
                callback(pathParams, queryParams);
            };
            Router.prototype.route.call(this, path, name, handler);
        },
        setPath: function (path, options) {
            // If we have new data not reflected on the page force a page load
            if (RivalIQ.state.landscape.isDirty()) {
                window.location = `/${path}`;
                return;
            }

            RivalIQ.execute('history:navigate', path, options);
        }
    });

});
